import { get } from "../lib/api";
import { servicebookingFlowStore } from "../store/ServiceBookingFlowStore";

export const getDoctorsWithFirstAvailable = async (
  serviceTypeId: string,
  lat?: number,
  long?: number
): Promise<{
  doctors: any[];
}> => {
  const params: Record<string, string> = {
    service_type_id: serviceTypeId,
  };

  if (lat !== undefined && long !== undefined) {
    params.lat = lat.toString();
    params.long = long.toString();
  }

  const response = await get(`doctors/with-first-available`, params);

  const doctors = Object.values(response);
  return {
    doctors,
  };
};


export const getDoctorsWithFirstAvailableForAptGroupId = async (
  aptGroupId: string,
  lat?: number,
  long?: number
): Promise<any[]> => {
  const params: Record<string, string> = {
    appointment_group_id: aptGroupId,
    accepts_new_patients: servicebookingFlowStore.configurationDetails?.doctors_accept_new_patients === true ? "1" : "0",
    has_first_available: servicebookingFlowStore.configurationDetails?.doctors_have_first_available === true ? "1" : "0",
    delay_first_available: servicebookingFlowStore.configurationDetails?.delay_first_available
  };

  if (lat !== undefined && long !== undefined) {
    params.lat = lat.toString();
    params.long = long.toString();
  }

  const response = await get(`doctors/with-first-available`, params);

  const doctors = Object.values(response);
  return doctors;
};

export const getDoctorsWithFirstAvailableByUserFkAndLocation = async (
  userFk: string,
  locationId: string,
  serviceTypeId?: string,
  appointmentTypeId?: string
): Promise<any[]> => {
  const params: Record<string, string> = {
    user_fk: userFk,
    location_id: locationId,
  };

  if (serviceTypeId) params.service_type_id = serviceTypeId;
  if (appointmentTypeId) params.appointment_type_id = appointmentTypeId;

  try {
    const response = await get(`doctors/with-first-available`, params);
    // console.log('Doctor API Raw Response:', response);

    return Object.values(response || {});
  } catch (error) {
    console.error('Doctor API Error:', error);
    return [];
  }
};

